
<template>
    <div>
        <vs-dialog v-model="active" prevent-close>
            <template #header>
                <h4 class="not-margin">
                    Desvincular a {{selectFam.apellido_paterno}} {{selectFam.apellido_materno}} {{selectFam.nombres}}
                </h4>
            </template>

            <div class="con-form">
                <div v-if="vinculaciones.cantidad > 1">
                    <p>Este familiar perderá su vinculación con <strong>{{general.datos.apellido_paterno}} {{general.datos.apellido_materno}} {{general.datos.nombres}}</strong>, sin embargo aún mantendrá relacion con los siguientes estudiantes:</p>
                    <div v-for="(vin, i) in vinculaciones.hijos" :key="i">
                        <p class="mt-1 mb-0" v-if="vin.id != general.datos.persona_id"><strong><i class="fas fa-caret-right mr-2"></i> {{vin.apellido_paterno}} {{vin.apellido_materno}} {{vin.nombres}}</strong></p>
                    </div>
                </div>
                <div v-if="vinculaciones.cantidad == 1">
                     {{selectFam.apellido_paterno}} {{selectFam.apellido_materno}} {{selectFam.nombres}} no mantiene vinculos con otros alumnos, por lo tanto será eliminado del sistema.
                </div>
            </div>
            <div class="d-flex mt-4">
                <div @click="active = false">
                    <div class="botonCancelar">
                        Cancelar
                    </div>
                </div>
                <vs-button
                    warn
                    class="ml-auto"
                    @click="postDesvincularFamiliar()"
                >
                    Desvincular
                </vs-button>
            </div>
        </vs-dialog>
    </div>  
</template>
<script>
import alumnos from '../../../../../../api/requests/alumno'
export default {
    props:[
      'value',
      'general',
      'selectFam',
      'vinculaciones'
    ],
    data(){
        return{
            active: false,
        }
    },
    methods:{
        async postDesvincularFamiliar(){
            const loading = this.$vs.loading()
            const tipo = this.general.datos.tipo
            const prospecto = this.general.datos.id
            const persona = this.general.datos.persona_id
            try{
                
                const params = {
                    familiar_id: this.selectFam.id,
                    persona_id: this.general.datos.persona_id
                }
                
                if(this.general.datos.tipo != 'prospecto'){
                    params.prospecto_id = this.general.datos.prospecto_id
                }else if(this.general.datos.tipo == 'prospecto'){
                    params.prospecto_id = this.general.datos.id
                }
                const {data: response} = await alumnos.postDesvincularFamiliar(params)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    icon: '<i class="fas fa-check"></i>',
                    title: 'Operación éxitosa',
                    text: 'Se ha desvinculado con éxito al familiar y/o tutor.'
                })
                loading.close()
                this.$emit('refreshComponent', tipo != 'prospecto' ? persona : prospecto)
                this.active = false
            }catch(error){
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    duration: 5000,
                    position: null,
                    title: 'Algo salío mal',
                    text: 'Favor de comunicarse con el administrador'
                })
                loading.close()
                this.active = false
            }
        }
    },
    watch:{
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
    }
}
</script>